"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROSPECTS = void 0;
var PROSPECTS = 'Prospects';
exports.PROSPECTS = PROSPECTS;